export const DATE_RANGE_TYPES = {DAY: 'day', MONTH: 'month', RANGE: 'range'};
  